var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMolecula(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.99 340.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e59f3c;}.cls-2{fill:#fff;stroke:#e59f3c;}.cls-2,.cls-3{stroke-miterlimit:10;stroke-width:4px;}.cls-3{fill:none;stroke:#1f2dd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "274.09 15.72 92.91 15.72 2.32 170.1 92.91 324.47 274.09 324.47 364.68 170.1 274.09 15.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.05,
    cy: 324.47,
    r: 15.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 91.45,
    cy: 17.93,
    r: 15.93
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecula);
export default __webpack_public_path__ + "static/media/molecula.31ac29ab168e46b46b6299139c70516c.svg";
export { ForwardRef as ReactComponent };